import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  align-self: start;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content-container {
    width: 1140px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 30px;
    gap: 0 32px;

    @media (max-width: 1024px) {
      display: none;
    }

    .image-container {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 36px;
    }
  }

  button {
    align-self: center;

    @media (max-width: 1024px) {
      display: none;
    }
  }

  .athletes-scroll {
    display: flex;
    flex-direction: row;
    width: 100%;

    padding-left: ${(props) => props.extraPad};
    scroll-behavior: smooth;

    @media (min-width: 1024px) {
      display: none;
    }

    .image-container {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      margin-right: 16px;
    }
  }
`;
const ImageBackground = styled.div`
  background: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 200px;
  height: 200px;
  margin-bottom: 8px;
`;

const Athletes = ({ selected, data }) => {
  const [extraPad, setExtraPad] = useState('0px'),
    athletesRef = useRef(null);

  useEffect(() => {
    handleExtraPad();
  }, []);

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2}px`);
  }

  return (
    <Wrapper>
      <div className="content-container">
        {data.map((x, i) => (
          <div className="image-container">
            <ImageBackground src={x.avatar || require('assets/branding/logo-icon-grey-10.png')} />

            {x.name}
          </div>
        ))}
      </div>

      <div
        className="athletes-scroll"
        style={{ paddingLeft: extraPad, overflowX: 'scroll' }}
        ref={athletesRef}
      >
        {data.map((x, i) => (
          <div className="image-container">
            <ImageBackground src={x.avatar} />

            {x.name}
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default Athletes;
